export default __webpack_public_path__ + "static/media/megaplanet365.ab633a47.svg";